import type { MailboxInfo } from 'owa-client-types';
import isCopilotFeatureEnabled from './isCopilotFeatureEnabled';
import { getIsCopilotUIDisabled } from 'owa-mail-copilot-settings/lib/selectors/getIsCopilotUIDisabled';

export function isProactiveDraftsEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        (isCopilotFeatureEnabled('ProactiveDrafts', mailboxInfo, true /* skipLanguageCheck */) ??
            false) &&
        !getIsCopilotUIDisabled(mailboxInfo)
    );
}
